<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DEZlIN/tc-custom/9783944389769_IMGJPG_FrontCover_0.jpg" alt="This image is the cover for the book In the Reign of Terror, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In the Reign of Terror, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Harry Sandwith, a Westminster boy, becomes a resident at the chateau of a French marquis, and after various adventures accompanies the family to Paris at the crisis of the Revolution. Imprisonment and death reduce their number, and the hero finds himself beset by perils with the three young daughters of the house in his charge . The stress of trial brings out in him all the best eng qualities of pluck and endurance, and after hair-breadth escapes they reach Nantes. There the girls are condemned to death in the coffin-ships Les Noyades, but are saved by the unfailing courage of their boy-protector.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        G. A. Henty
      </h2>
      
      <p class="authorDescription body article">George Alfred Henty (8 December 1832 – 16 November 1902) was a prolific English novelist and war correspondent. He is best known for his historical adventure stories that were popular in the late 19th century. His works include The Dragon & The Raven (1886), For The Temple (1888), Under Drake's Flag (1883) and In Freedom's Cause (1885). (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06b85192